/** Merge server upload queue with local cache (ISSUE-06 — server wins on status). */

function itemTimestamp(item) {
  const value = item?.createdAt || item?.created_at || item?.updatedAt || item?.updated_at;
  const parsed = value ? Date.parse(value) : 0;
  return Number.isNaN(parsed) ? 0 : parsed;
}

function normalizeServerComprobante(row) {
  const rawLabel = (row.comprobanteLabel || '').trim();
  const invoiceMatch = rawLabel.match(/^invoices\s*·\s*(.+)$/i);
  const fiscalLabel = invoiceMatch ? invoiceMatch[1].trim() : rawLabel;
  const text = fiscalLabel.toLowerCase();
  let subtype = null;
  if (/nota de cr[eé]dito|credito|crédito/.test(text)) subtype = 'CREDITO';
  else if (/nota de d[eé]bito|debito|débito/.test(text)) subtype = 'DEBITO';
  else if (/factura/.test(text)) subtype = 'INVOICE';

  return {
    docType: invoiceMatch ? 'invoices' : row.docType,
    fiscalLabel,
    subtype,
    isClassifiedInvoice: Boolean(invoiceMatch),
  };
}

export function mapServerUploadItem(row) {
  const fiscal = normalizeServerComprobante(row);
  const status = row.status === 'needs_review' && fiscal.isClassifiedInvoice ? 'done' : (row.status || 'queued');
  const active = ['uploading', 'presigning', 'validating'].includes(status);
  const terminal = ['done', 'error', 'duplicate', 'needs_review', 'rejected', 'upload_error'].includes(status);
  return {
    id: row.uploadId || row.documentId || `srv-${row.createdAt || Date.now()}`,
    upload_id: row.uploadId || null,
    doc_id: row.documentId || null,
    name: row.filename || 'archivo',
    size: row.sizeBytes || 0,
    status,
    pct: terminal ? 100 : active ? 0 : undefined,
    error: row.errorMessage || null,
    doc_type: fiscal.docType || null,
    duplicate_of: row.duplicateOf || null,
    comprobante_label: fiscal.fiscalLabel || null,
    comprobante_subtype: fiscal.subtype,
    arca_validation: row.arcaValidation || null,
    createdAt: row.createdAt || null,
    updatedAt: row.updatedAt || row.createdAt || null,
    file: null,
  };
}

export function mergeUploadQueues(serverRows, localItems) {
  const merged = new Map();

  for (const row of serverRows || []) {
    const item = mapServerUploadItem(row);
    const key = item.upload_id || item.doc_id || item.id;
    merged.set(key, item);
  }

  for (const item of localItems || []) {
    const key = item.upload_id || item.doc_id || item.id;
    const server = merged.get(key);
    if (server) {
      const serverTerminal = ['done', 'error', 'duplicate', 'needs_review', 'rejected', 'upload_error'].includes(server.status);
      const localTerminal = ['done', 'error', 'duplicate', 'needs_review', 'rejected', 'upload_error'].includes(item.status);
      const localActive = !serverTerminal
        && item.file
        && ['uploading', 'presigning', 'validating'].includes(item.status);
      const keepLocalTerminal = localTerminal && !serverTerminal;
      merged.set(key, {
        ...server,
        id: item.id || server.id,
        file: item.file || null,
        createdAt: item.createdAt || server.createdAt,
        status: localActive || keepLocalTerminal ? item.status : server.status,
        pct: localActive || keepLocalTerminal ? item.pct : server.pct,
        error: localActive || keepLocalTerminal ? item.error : server.error,
        arca_validation: server.arca_validation || item.arca_validation || null,
        updatedAt: localActive ? (item.updatedAt || server.updatedAt) : server.updatedAt,
      });
    } else {
      merged.set(key, item);
    }
  }

  return Array.from(merged.values())
    .sort((a, b) => itemTimestamp(b) - itemTimestamp(a))
    .slice(0, 5);
}
